import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {getTransformationsPointer} from '../../conversionDal/utils/pointer'
import {createAdaptiveHeuristic, updateTransformations} from '../common'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const setRotationToZero = (componentStageData: ComponentStageData) => {
        const {componentPointer, conversionDal} = componentStageData
        const transformations = conversionDal.get(getTransformationsPointer(componentPointer))
        if (transformations?.rotate) updateTransformations(componentStageData, {rotate: 0})
    }
    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.POST_PROCESS, createAdaptiveHeuristic(setRotationToZero))
    }

    const name = 'cancelRotation'
    return {register, name}
}
